module.exports = __webpack_public_path__ + "static/img/45.4f61598.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/45.png
// module id = F/Jz
// module chunks = 1